import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKyrgyzstan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_548)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.8686 12L15.4707 13.1279L16.7476 15.4504L14.1436 14.9522L13.8137 17.5826L11.9999 15.6481L10.1862 17.5826L9.85627 14.9522L7.25246 15.4503L8.52933 13.1278L6.13135 12L8.52933 10.8721L7.25246 8.54958L9.85618 9.04786L10.1863 6.41738L11.9999 8.35195L13.8138 6.41738L14.1436 9.04786L16.7477 8.54958L15.4707 10.8723L17.8686 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 15.6522C14.017 15.6522 15.6521 14.017 15.6521 12C15.6521 9.98296 14.017 8.34783 11.9999 8.34783C9.98291 8.34783 8.34778 9.98296 8.34778 12C8.34778 14.017 9.98291 15.6522 11.9999 15.6522Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1739 12C10.0859 12 9.99906 12.0045 9.91333 12.013C9.91647 12.5189 10.0995 12.9818 10.4017 13.3415C10.563 12.9076 10.8037 12.5119 11.1073 12.1733C10.8174 12.0618 10.5028 12 10.1739 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2981 13.9656C11.5175 14.044 11.7537 14.087 12 14.087C12.2464 14.087 12.4826 14.044 12.702 13.9656C12.5824 13.4963 12.3355 13.0773 12 12.7481C11.6646 13.0773 11.4177 13.4963 11.2981 13.9656Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8073 10.9568C13.4464 10.3331 12.7725 9.91303 12 9.91303C11.2275 9.91303 10.5536 10.3331 10.1927 10.9568C10.8506 10.9602 11.4675 11.139 12 11.4479C12.5326 11.139 13.1493 10.9602 13.8073 10.9568Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8926 12.1733C13.1962 12.5119 13.4369 12.9076 13.5982 13.3416C13.9004 12.9819 14.0834 12.5189 14.0866 12.0131C14.0008 12.0045 13.9139 12 13.826 12C13.4972 12 13.1826 12.0618 12.8926 12.1733Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_548",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgKyrgyzstan;
